import React from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormText,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row,
} from 'reactstrap';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { compose } from 'recompose';
import { ApiDataBinding, withApiData } from 'react-api-data';
import { RouteComponentProps } from 'react-router';
import qs from 'qs';
import LoaderButton from 'components/utils/LoaderButton';

interface FormData {
    password: string;
    password_confirmation: string;
}

interface ApiProps {
    completeRegistrationBinding: ApiDataBinding<any>;
}

type Props = ApiProps & RouteComponentProps;

function CompleteRegistration(props: Props) {
    const { t } = useTranslation();
    const { completeRegistrationBinding } = props;
    const { token } = qs.parse(props.location.search, { ignoreQueryPrefix: true }) as { token: string };

    function onSubmit(values: FormData) {
        completeRegistrationBinding.perform(undefined, { ...values, token });
    }

    return (
        <div className="app flex-row align-items-center">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={6}>
                        <Card className="p-4">
                            <CardBody>
                                <CardTitle tag="h1">{t('completeRegistration.title')}</CardTitle>
                                <Formik
                                    data-test="form"
                                    initialValues={{ password: '', password_confirmation: '' } as FormData}
                                    onSubmit={onSubmit}
                                >
                                    {({ handleChange, handleSubmit }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <InputGroup className="mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-lock" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    type="password"
                                                    placeholder={t('common.passwordPlaceholder')}
                                                    autoComplete="new-password"
                                                    name="password"
                                                    id="password"
                                                    onChange={handleChange}
                                                    autoFocus
                                                    required
                                                />
                                                <FormText>{t('common.passwordInstructions')}</FormText>
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-lock" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    type="password"
                                                    placeholder={t('common.passwordConfirmationPlaceholder')}
                                                    autoComplete="new-password"
                                                    name="password_confirmation"
                                                    id="password_confirmation"
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </InputGroup>
                                            <Row>
                                                <Col xs="6">
                                                    <LoaderButton type="submit" loading={false}>
                                                        {t('completeRegistration.submitBtn')}
                                                    </LoaderButton>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </Formik>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default compose<Props, RouteComponentProps>(
    withApiData({ completeRegistrationBinding: 'putCompleteRegistration' })
)(CompleteRegistration);
